import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ChartType, ChartOptions } from 'chart.js';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';
import * as moment from 'moment';
import { statusSkuld } from 'src/app/modules/case-new-view/components/case-tabs/stepper-skuld/stepper-skuld.component';
import { statusAlert } from 'src/app/modules/case-new-view/components/case-tabs/datos-caso-skuld/datos-caso-skuld.component';
import { SERIES, opcionesBarraHorizontal, serieBarra } from 'src/app/modules/dashboard/utils/chart-estilo-v2';

@Component({
  selector: 'app-report-cases',
  templateUrl: './report-cases.component.html',
  styleUrls: ['./report-cases.component.scss'],
})
export class ReportCasesComponent implements OnInit {
  dateRangeForm!: FormGroup;
  contadorService: number = 0;
  allInfoChart;
  colors = CHARTS_COLORS;
  colorIndex = 0;
  estados = ['Rechazado', 'Urgentes'];
  viewOptions = [
    { value: '02', label: 'Rechazado' },
    { value: '03', label: 'Urgentes' },
  ];
  castStatus = statusSkuld;
  castDecision = statusAlert;
  charts: any[] = [];
  headerTable = [];
  infoTable = [];
  infoAll = [];
  readonly FORMATO_DESEADO: string = 'D/MM/YYYY h:mm:ss A';
  verGraficas: boolean = true;
  barChartType: ChartType = 'bar';
  chartLegend = true;
  chartPlugins = [];
  /** Paginado */
  cambiarVista() {
    this.verGraficas = !this.verGraficas;
    this.setRequired('code');
  }

  constructor(
    private readonly alertService: AlertService,
    private fb: FormBuilder
  ) {}

  get f() {
    return this.dateRangeForm.controls;
  }
  ngOnInit(): void {
    this.dateRangeForm = this.fb.group(
      {
        beging: ['', Validators.required],
        end: ['', Validators.required],
        code: [],
      },
      {
        // Aplicamos el validador a nivel de FormGroup
        validator: dateRangeValidator,
      }
    );
    this.getReport();
  }
  barOptions(etiquetax, etiquetay): ChartOptions {
    const barChartOptions: ChartOptions = {
      responsive: true,
      // Asegura que las barras se apilen
      scales: {
        xAxes: [
          {
            stacked: true, // <-- ¡Importante! Hace que las barras se apilen horizontalmente
            gridLines: {
              display: false,
            },
            scaleLabel: {
              display: etiquetax ? true : false,
              labelString: etiquetax,
              fontColor: '#555',
              fontSize: 14,
            },
          },
        ],
        yAxes: [
          {
            stacked: true, // <-- ¡Importante! Hace que las barras se apilen verticalmente (en la cuenta)
            ticks: {
              beginAtZero: true, // Siempre bueno comenzar en cero
            },
            scaleLabel: {
              display: etiquetay ? true : false,
              labelString: etiquetay,
              fontColor: '#555',
              fontSize: 14,
            },
          },
        ],
      },
      //title: {
      //  display: true,
      //  text: 'Ventas Trimestrales por Producto'
      //},
      // Opcional: Para mostrar las etiquetas de datos (requiere chartjs-plugin-datalabels)
      // plugins: {
      //   datalabels: {
      //     formatter: (value, ctx) => {
      //       return value; // Muestra el valor de cada segmento
      //     },
      //     color: 'white',
      //   }
      // }
    };
    return barChartOptions;
  }
  actualizarColorIndex(currentIndex: number): number {
    return (currentIndex + 1) % this.colors.length;
  }
  organizarCharts() {
    if (this.contadorService == 0) {
      this.charts = [];
      // preparar datos para el grafico
      const cantRecha =
        this.allInfoChart?.resultCode?.find((i) => i._id === '02')?.amount ?? 0;
      const cantUrge =
        this.allInfoChart?.resultCode?.find((i) => i._id === '03')?.amount ?? 0;

      this.charts.push({
        chartName:
          'Total General de Alertas Recibidas (Rechazadas + Urgentes). Total: ' +
          (cantRecha + cantUrge),
        chartType: 'horizontalBar',
        // Estilo de Skuld OSINT, con la misma proporcion que los otros graficos del reporte
        chartOptions: { ...opcionesBarraHorizontal(), maintainAspectRatio: true },
        chartLabels: this.estados,
        chartData: [
          {
            data: [cantRecha, cantUrge],
            label: 'Alertas',
            ...serieBarra(SERIES[0]),
            // Los colores de Rechazado y Urgentes que tenia la torta
            backgroundColor: ['#1B2232', '#9EACC6'],
            hoverBackgroundColor: ['#1B2232', '#9EACC6'],
          },
        ],
        // Las etiquetas del eje ya dicen que es cada barra
        chartLegend: false,
      });

      /** falso positivo */
      let barFalsosPositivos = [];
      const bfpRechazados = this.allInfoChart?.resultCodeStatus?.find(
        (s) => s.code === '02'
      );
      if (bfpRechazados) {
        barFalsosPositivos.push({
          data: [
            bfpRechazados?.amounts?.find((i) => i.status === 'proceed')
              ?.amount ?? 0,
            bfpRechazados?.amounts?.find((i) => i.status === 'refused')
              ?.amount ?? 0,
          ],
          label: this.estados[0], // Primera serie de barras
          backgroundColor: this.colors[this.colorIndex].backgroundColor,
          borderColor: this.colors[this.colorIndex].borderColor,
          hoverBackgroundColor: this.colors[this.colorIndex].backgroundColor,
          hoverBorderColor: this.colors[this.colorIndex].borderColor,
          borderWidth: 1,
        });
      }
      this.colorIndex = this.actualizarColorIndex(this.colorIndex);
      const bfpUrgentes = this.allInfoChart?.resultCodeAddInfoStatus?.find(
        (s) => s.code === '03'
      );
      if (bfpUrgentes) {
        barFalsosPositivos.push({
          data: [
            bfpUrgentes?.amounts?.find((i) => i.status === 'rechazar')?.amount ??
              0,
            bfpUrgentes?.amounts?.find((i) => i.status === 'confirmar')?.amount ??
              0,
          ],
          label: this.estados[1], // Primera serie de barras
          backgroundColor: this.colors[this.colorIndex].backgroundColor,
          borderColor: this.colors[this.colorIndex].borderColor,
          hoverBackgroundColor: this.colors[this.colorIndex].backgroundColor,
          hoverBorderColor: this.colors[this.colorIndex].borderColor,
          borderWidth: 1,
        });
      }
      this.colorIndex = this.actualizarColorIndex(this.colorIndex);
      this.charts.push({
        chartName: 'Total Alertas: "Falsos Positivos" y "Fraudes"',
        chartType: this.barChartType,
        chartOptions: this.barOptions('', ''),
        chartLabels: ['Fraudes', 'Falsos Positivos'],
        chartData: barFalsosPositivos,
        chartLegend: this.chartLegend,
      });

      /** falso positivo */

      var barChartsData = [];
      const rechazadoData = this.allInfoChart?.resultChannel?.find(
        (i) => i.code === '02'
      );
      let rechazadaVal = [];
      let rechazadaLabel = [];
      rechazadoData?.amounts?.forEach((element) => {
        rechazadaVal.push(element.amount);
        rechazadaLabel.push(element.canal);
      });
      barChartsData.push({
        data: rechazadaVal,
        label: this.estados[0], // Primera serie de barras
        backgroundColor: this.colors[this.colorIndex]?.backgroundColor, // Azul
        borderColor: this.colors[this.colorIndex]?.borderColor,
        hoverBackgroundColor: this.colors[this.colorIndex].backgroundColor,
        hoverBorderColor: this.colors[this.colorIndex].borderColor,
        borderWidth: 1,
      });
      this.colorIndex = this.actualizarColorIndex(this.colorIndex);
      const urgenteData = this.allInfoChart?.resultChannel?.find(
        (i) => i.code === '03'
      );
      let urgenteVal = [];
      let urgenteLabel = [];
      urgenteData?.amounts?.forEach((element) => {
        urgenteVal.push(element.amount);
        urgenteLabel.push(element.canal);
      });
      barChartsData.push({
        data: urgenteVal,
        label: this.estados[1], // Primera serie de barras
        backgroundColor: this.colors[this.colorIndex]?.backgroundColor, // Azul
        borderColor: this.colors[this.colorIndex]?.borderColor,
        hoverBackgroundColor: this.colors[this.colorIndex].backgroundColor,
        hoverBorderColor: this.colors[this.colorIndex].borderColor,
        borderWidth: 1,
      });
      this.colorIndex = this.actualizarColorIndex(this.colorIndex);
      this.charts.push({
        chartName: 'Total por Canal: Alertas Recibidas (Rechazadas + Urgentes)',
        chartType: this.barChartType,
        chartOptions: this.barOptions('Canal', 'Numero de Alertas'),
        chartLabels: rechazadaLabel,
        chartData: barChartsData,
        chartLegend: this.chartLegend,
      });
      var barChartsDataEspecialista = [];
      let especialistaLabel = [];
      let especialistaVal = [];
      this.allInfoChart?.resultAssigne?.forEach((element) => {
        especialistaLabel.push(element?.assigned);
        especialistaVal.push([
          element?.amounts?.find((i) => i.code === '02')?.amount ?? 0,
          element?.amounts?.find((i) => i.code === '03')?.amount ?? 0,
        ]);
      });
      especialistaVal = this.transposeArray(especialistaVal);
      especialistaVal?.forEach((element, index) => {
        barChartsDataEspecialista.push({
          data: element,
          label: this.estados[index], // Primera serie de barras
          backgroundColor: this.colors[this.colorIndex]?.backgroundColor, // Azul
          borderColor: this.colors[this.colorIndex]?.borderColor,
          hoverBackgroundColor: this.colors[this.colorIndex].backgroundColor,
          hoverBorderColor: this.colors[this.colorIndex].borderColor,
          borderWidth: 1,
        });
        this.colorIndex = this.actualizarColorIndex(this.colorIndex);
      });
      this.charts.push({
        chartName:
          'Total General: Alertas Recibidas por Especialista (Rechazadas + Urgentes)',
        chartType: this.barChartType,
        chartOptions: this.barOptions('Especialista', 'Numero de Alertas'),
        chartLabels: especialistaLabel,
        chartData: barChartsDataEspecialista,
        chartLegend: this.chartLegend,
      });
      this.allInfoChart?.resultAssigneChannel?.forEach((element) => {
        let especialistaLabel = [];
        let especialistaVal = [];
        element?.channels?.forEach((e) => {
          especialistaLabel.push(e?.channel);
          especialistaVal.push([
            e?.alert_types?.find((i) => i.type === '02')?.amount ?? 0,
            e?.alert_types?.find((i) => i.type === '03')?.amount ?? 0,
          ]);
        });
        especialistaVal = this.transposeArray(especialistaVal);
        var chartAssignedChannel = [];
        especialistaVal?.forEach((e, index) => {
          chartAssignedChannel.push({
            data: e,
            label: this.estados[index], // Primera serie de barras
            backgroundColor: this.colors[this.colorIndex]?.backgroundColor, // Azul
            borderColor: this.colors[this.colorIndex]?.borderColor,
            hoverBackgroundColor: this.colors[this.colorIndex].backgroundColor,
            hoverBorderColor: this.colors[this.colorIndex].borderColor,
            borderWidth: 1,
          });

          this.colorIndex = this.actualizarColorIndex(this.colorIndex);
        });
        this.charts.push({
          chartName:
            'Total por Canal: Alertas Recibidas por Especialista (Rechazadas + Urgentes) - ' +
            element.assigned,
          chartType: this.barChartType,
          chartOptions: this.barOptions('Canal', 'Numero de Alertas'),
          chartLabels: especialistaLabel,
          chartData: chartAssignedChannel,
          chartLegend: this.chartLegend,
        });
      });
    }
  }
  getReport(filter: any = {}) {
    if (filter.beging || filter.end) filter.date = true;
    this.contadorService++;
    this.alertService.getAlertReport(filter).subscribe((res) => {
      this.allInfoChart = res;
      this.contadorService--;
      this.organizarCharts();
    });
  }
  getReportCode(filter: any = {}) {
    if (filter.beging || filter.end) filter.date = true;
    this.infoAll = [];
    this.alertService.getReportsDetail(filter).subscribe((res) => {
      this.organizarReporteDetallado(res, filter.code);
    });
  }
  onSubmit() {
    if (this.dateRangeForm.valid) {
      if (this.verGraficas) {
        let dataObject = this.dateRangeForm.value;
        delete dataObject.code;
        this.getReport(dataObject);
      } else {
        this.getReportCode(this.dateRangeForm.value);
      }
    } else {
      this.dateRangeForm.markAllAsTouched();
    }
  }
  organizarReporteDetallado(res, code) {
    const esRechazado = code === '02';
    this.headerTable = esRechazado ? HEADER_RECHAZADOS : HEADER_URGENTES;
    this.infoTable = [];
    this.infoAll = [];
    this.infoAll.push(this.headerTable);
    if (esRechazado) {
      res?.forEach((element) => {
        this.infoAll.push([
          'Rechazado',
          element?.alerta?.tipo_registro,
          element?.case?.uidTransaction ?? element?.alerta?.uidTransaction,
          element?.alerta?.instrumento,
          element?.alerta?.instrumento_destino,
          element?.assigned_user?.fullname,
          this.castStatus[element?.alerta?.status],
          moment(new Date(element?.case?.toAssignedAt)).format(
            this.FORMATO_DESEADO
          ),
          moment(new Date(element?.alerta?.createdAt)).format(
            this.FORMATO_DESEADO
          ),
          element?.alerta?.canal,
          element?.creator_user?.fullname,
          element?.alerta?.monto_salio,
          this.castDecision[element?.case?.additionalInformationStatus],
          element?.alerta?.type,
          element?.alerta?.code,
          element?.alerta?.tipo_de_persona,
          element?.alerta?.apellido,
          element?.alerta?.oficina,
          element?.alerta?.telefono,
          element?.alerta?.celular,
          element?.alerta?.domicilio,
          element?.alerta?.numero_de_identificacion,
          element?.alerta?.nombre,
          element?.alerta?.region,
          element?.alerta?.correo,
          element?.alerta?.cliente,
        ]);
      });
    } else {
      res?.forEach((element) => {
        this.infoAll.push([
          'Urgente',
          element?.alerta?.tipo_registro,
          element?.case?.uidTransaction ?? element?.alerta?.uidTransaction,
          element?.alerta?.instrumento,
          element?.alerta?.instrumento_destino,
          element?.assigned_user?.fullname,
          this.castStatus[element?.alerta?.status],
          moment(new Date(element?.alerta?.createdAt)).format(
            this.FORMATO_DESEADO
          ),
          element?.alerta?.canal,
          element?.creator_user?.fullname,
          element?.alerta?.monto_salio,
          element?.alerta?.code,
          element?.alerta?.tipo_de_persona,
          element?.alerta?.apellido,
          element?.alerta?.oficina,
          element?.alerta?.telefono,
          element?.alerta?.celular,
          element?.alerta?.domicilio,
          element?.alerta?.numero_de_identificacion,
          element?.alerta?.nombre,
          element?.alerta?.region,
          element?.alerta?.correo,
          element?.alerta?.cliente,
        ]);
      });
    }
  }

  /**
   * Transpone una matriz de 2xN o Nx2.
   * @param array La matriz original [[a, b], [c, d], ...]
   * @returns La matriz transpuesta [[a, c, ...], [b, d, ...]]
   */
  transposeArray(array: number[][]): number[][] {
    if (!array || array.length === 0) {
      return [];
    }

    // Determinamos el número de columnas de la matriz original (que será el número de filas de la transpuesta).
    const numRows = array.length;
    const numCols = array[0].length;

    // Inicializamos el array de resultado con el tamaño correcto.
    // Creamos 'numCols' subarrays (que serán las nuevas filas).
    const result: number[][] = Array.from({ length: numCols }, () => []);

    // Recorremos la matriz original para llenar la matriz transpuesta.
    for (let i = 0; i < numRows; i++) {
      for (let j = 0; j < numCols; j++) {
        // El elemento en [i, j] de la original va a [j, i] en la transpuesta.
        result[j].push(array[i][j]);
      }
    }

    return result;
  }

  setRequired(atribute: string | null): void {
    const codeControl = this.dateRangeForm.get(atribute) as AbstractControl;

    if (this.verGraficas) {
      codeControl.clearValidators();
    } else {
      codeControl.setValidators(Validators.required);
    }

    codeControl.updateValueAndValidity();
  }
}

export const CHARTS_COLORS = [
  {
    backgroundColor: '#1B2232',
    borderColor: '#1B2232',
    pointBackgroundColor: '#1B2232',
    pointBorderColor: '#fff',
  },
  {
    backgroundColor: '#9EACC6',
    borderColor: '#9EACC6',
    pointBackgroundColor: '#9EACC6',
    pointBorderColor: '#fff',
  },
  {
    backgroundColor: '#5B93FF',
    borderColor: '#5B93FF',
    pointBackgroundColor: '#5B93FF',
    pointBorderColor: '#fff',
  },
  {
    backgroundColor: '#34C53A',
    borderColor: '#34C53A',
    pointBackgroundColor: '#34C53A',
    pointBorderColor: '#fff',
  },
  {
    backgroundColor: '#D96657',
    borderColor: '#D96657',
    pointBackgroundColor: '#D96657',
    pointBorderColor: '#fff',
  },
  {
    backgroundColor: '#BCBE43',
    borderColor: '#BCBE43',
    pointBackgroundColor: '#BCBE43',
    pointBorderColor: '#fff',
  },
  {
    backgroundColor: '#A664DA',
    borderColor: '#A664DA',
    pointBackgroundColor: '#A664DA',
    pointBorderColor: '#fff',
  },
];

/**
 * Validador cruzado para asegurar que la diferencia entre fechaFin y fechaInicio no
 * exceda un año (366 días para cubrir años bisiestos).
 * Se aplica al FormGroup.
 */
export const dateRangeValidator: ValidatorFn = (
  formGroup: FormGroup
): ValidationErrors | null => {
  const startDateControl = formGroup.get('beging');
  const endDateControl = formGroup.get('end');

  // Si no hay valores en ambos, la validación se considera exitosa a este nivel
  // (asumiendo que Validators.required se aplica a los controles individuales).
  if (!startDateControl?.value || !endDateControl?.value) {
    return null;
  }

  // Convertir a objetos Date
  const startDate = new Date(startDateControl.value);
  const endDate = new Date(endDateControl.value);

  // 1. Validar que la Fecha de Fin no sea anterior a la de Inicio
  if (endDate.getTime() < startDate.getTime()) {
    // Establecer un error en el control endDate para mostrar el mensaje de error allí
    endDateControl.setErrors({ fechaInvalida: true });
    return { rangoInvalido: true };
  } else {
    // Si la validación pasa, eliminar el error si existía
    if (endDateControl.hasError('fechaInvalida')) {
      // Eliminar solo el error específico, manteniendo otros
      const errors = endDateControl.errors;
      delete errors!['fechaInvalida'];
      endDateControl.setErrors(Object.keys(errors!).length > 0 ? errors : null);
    }
  }

  // 2. Validar que la diferencia no exceda 1 año (366 días en milisegundos)
  const MS_PER_YEAR = 1000 * 60 * 60 * 24 * 366; // Aproximadamente 1 año
  const diffTime = Math.abs(endDate.getTime() - startDate.getTime());

  if (diffTime > MS_PER_YEAR) {
    return {
      limiteAnualExcedido: {
        maxRange: '366 días',
      },
    };
  }

  return null;
};

export const HEADER_RECHAZADOS: string[] = [
  'Alerta',
  'Tipo de registro',
  'VU UID',
  'Datos del instrumento financiero',
  'Datos instrumento destino',
  'Analista responsable',
  'Estado del alerta',
  'Fecha de asignación',
  'Fecha de creación',
  'Canal',
  'Gerente responsable',
  'Monto de la transacción',
  'Decisión',
  'Tipo',
  'Código',
  'Tipo de persona',
  'Apellidos',
  'Oficina/Agencia',
  'Teléfono de contacto',
  'Celular',
  'Domicilio del cliente',
  'CI/RIF',
  'Nombre de la persona',
  'Región',
  'Email',
  'Cliente',
];

export const HEADER_URGENTES: string[] = [
  'Alerta',
  'Tipo de registro',
  'VU UID',
  'Datos del instrumento financiero',
  'Datos instrumento destino',
  'Analista responsable',
  'Estado del alerta',
  'Fecha de creación',
  'Canal',
  'Gerente responsable',
  'Monto de la transacción',
  'Código',
  'Tipo de persona',
  'Apellidos',
  'Oficina/Agencia',
  'Teléfono de contacto',
  'Celular',
  'Domicilio del cliente',
  'CI/RIF',
  'Nombre de la persona',
  'Región',
  'Email',
  'Cliente',
];
